function sectionsScroll() {
  $(document).ready(function () {

    var sections = $('.node--type-flexible-landing-page-about.node--view-mode-full .field--name-field-section > .field__item > .paragraph');

    if (!sections.length) {
      return;
    }

    var navLinks = $('.menu-container .field--name-field-menu .field__item a');
    var header = $('.content-header .region-header'); // change selector if needed
    var headerHeight = header.length ? header.outerHeight() : 0;

    function setActiveSection() {
      var scrollPosition = $(window).scrollTop();
      var offset = headerHeight + 10;

      sections.each(function () {
        var top = $(this).offset().top - offset;
        var bottom = top + $(this).outerHeight();

        if (scrollPosition >= top && scrollPosition < bottom) {
          var id = $(this).attr('id');

          navLinks.removeClass('active');
          navLinks.filter('[href="#' + id + '"]').addClass('active');

          return false;
        }
      });
    }

    setActiveSection();

    $(window).on('scroll', setActiveSection);
    $(window).on('resize', setActiveSection);
  });
}
